import React from 'react';

export const Bold = (props: {children: React.ReactNode}) => (<span style={{fontWeight: 'bold'}}>{props.children}</span>);
